import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import {
  AprovarOuReprovarCredenciamentoEmissorRequest,
  CommandResultTyped,
  CredenciadoEmissorRequest,
} from 'common/genericTypes';
import { CredenciadosResponse } from 'store/modules/credenciados/credenciadosReponse';

export const POSTCredenciadoVSEmissor = async (
  dispatch: Dispatch,
  credenciadoEmissor: CredenciadoEmissorRequest,
  stackRequest: boolean = false
) => {
  const body: any = new FormData();
  body.append('cnpjEmissor', credenciadoEmissor.cnpjEmissor);
  if (credenciadoEmissor.attachments.length > 0) {
    credenciadoEmissor.attachments.forEach((document, index) => {
      body.append(`documents[${index}].file`, document.file);
      body.append(`documents[${index}].emissionType`, document.emissionType);
    });
  }
  return await request(
    () =>
      axiosInstance.post<string>(`${requestConfig.api}api/v1/credenciados`, body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCredenciados = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<CommandResultTyped<CredenciadosResponse[]>>(`${requestConfig.api}api/v1/credenciados`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETByIdCredenciado = async (dispatch: Dispatch, id: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<CommandResultTyped<CredenciadosResponse>>(`${requestConfig.api}api/v1/credenciados/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PATCHAprovarOuReprovarCredenciamentoEmissor = async (
  dispatch: Dispatch,
  id: string,
  aproveOrReproveRequest: AprovarOuReprovarCredenciamentoEmissorRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.patch<any>(`${requestConfig.api}api/v1/credenciados/${id}`, aproveOrReproveRequest),
    dispatch,
    id.toString(),
    stackRequest
  );
};
